import { PropertyOverviewBlock } from "@/payload-types";
import { useForm } from "@tanstack/react-form-nextjs";
import { getRelationshipObject, resolveRelationshipId } from "@/lib/utils/theme-configuration-class";
import { cn } from "@/lib/utils";
import { useMemo } from "react";
import { PropertyOverviewFilters } from "@/blocks/property-overview/data";
import { RenderFilters, SelectedFilters } from "@/lib/blocks/render-filters";
import { buildFilterDefaultValues } from "@/lib/marketsuite/filters/default-values";
import { useFilterData } from "@/lib/marketsuite/filters/use-filter-data";

interface PropertyOverviewFiltersCardProps {
	filters: PropertyOverviewFilters;
	setSelectedFilters: (filters: SelectedFilters) => void;
	selectedFilters: SelectedFilters;
	formVariant?: NonNullable<NonNullable<PropertyOverviewBlock["settings"]>["filterFormVariant"]>;
}

const PropertyOverviewFiltersForm: React.FC<PropertyOverviewFiltersCardProps> = ({ formVariant = "default", filters, setSelectedFilters, selectedFilters }) => {
	const filterset = useMemo(() => getRelationshipObject(filters?.filterset), [filters?.filterset]);

	if (!filterset) return null;

	const filterData = useFilterData(filterset, selectedFilters);

	const formDefaultValues = useMemo(
		() => buildFilterDefaultValues(filterset, filters.defaultFilters?.filters as Record<string, string> | undefined),
		[filterset, filters.defaultFilters?.filters],
	);

	const form = useForm({
		defaultValues: formDefaultValues,
		onSubmit: async ({ value }) => {
			setSelectedFilters(value as SelectedFilters);
		},
	});

	if (filterset && filterset.filters?.length) {
		return (
			<form
				className={cn("ms-form-" + resolveRelationshipId(formVariant), "space-y-3.5")}
				onSubmit={(e) => {
					e.preventDefault();
					e.stopPropagation();
					form.handleSubmit();
				}}
			>
				<RenderFilters
					filterset={filterset}
					defaultFilters={filters.defaultFilters}
					filterData={filterData ?? undefined}
					selectedFilters={selectedFilters}
					form={form}
					formVariant={formVariant}
					onValueChange={(value, blockType) => setSelectedFilters({ ...selectedFilters, [blockType]: value })}
				/>
			</form>
		);
	}

	return null;
};

export default PropertyOverviewFiltersForm;
